<div class="request-quote-wrapper-dialog" style="padding: 2em">
  <ng-container *ngIf="!requestStatus; else requestSent">
    <h1 mat-dialog-title class="float-left w-100">Request quote</h1>
    <div
      mat-dialog-content
      style="max-height: 80vh !important"
      class="float-left w-100 m-0 form-wrapper"
    >
      <app-field *ngFor="let field of fields" [field]="field"></app-field>
    </div>
    <ng-container *ngIf="!reCaptchaCheck.valid; else actionButton">
      <div class="reCaptchaContainer">
        <form [formGroup]="reCaptchaCheck">
          <ngx-recaptcha2
            #captchaElem
            [siteKey]="siteKey"
            formControlName="recaptcha"
          >
          </ngx-recaptcha2>
        </form>
      </div>
    </ng-container>
    <ng-template #actionButton>
      <button
        mat-flat-button
        pally-rounded-button-l
        color="accent"
        (click)="sendRequest()"
        [disabled]="!reCaptchaCheck.valid"
      >
        <mat-icon> send </mat-icon> Send request
      </button>
    </ng-template>
  </ng-container>
  <ng-template #requestSent>
    <ng-container [ngSwitch]="requestStatus">
      <ng-container *ngSwitchCase="'succeed'">
        <div class="form-status">
          <div mat-card-avatar class="form-status-checkmark">
            <app-checkmark></app-checkmark>
          </div>
          <div class="form-status-text">
            <h2>What happens next:</h2>
            <span>
              We will connect you with a certified partner who can deliver and
              give you a quote for this solution.
            </span>
            <br />
            <span>
              The partner will then be the one delivering your quote to you.
            </span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'failed'">
        <div class="form-status">
          <div class="form-status-icon">
            <mat-icon>error_outline</mat-icon>
          </div>
          <div class="form-status-text">
            <h2>Something went wrong</h2>
            <span>
              This request can only be sent once per simulation. If you already
              requested it, please wait patiently.
            </span>
            <br />
            <span>
              The partner will then be the one delivering your quote to you.
            </span>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <button
      mat-flat-button
      pally-rounded-button-l
      color="primary"
      (click)="close()"
    >
      Back to simulation
    </button>
  </ng-template>
</div>
